import { ErrorType } from '@treasury/domain/channel/mappings/security';
import { TmButtonType } from '@treasury/presentation/components/tm-button.types';
import { html, nothing } from 'lit';
import {
    IdentityDialogContext,
    IdentityDialogStrategy,
} from '../identity-verification-dialog.types';

export class Oob implements IdentityDialogStrategy {
    constructor(private readonly context: IdentityDialogContext) {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public async validateAccountPassword(password: string) {
        throw new Error('Validating account password is not valid for legacy OOB authentication.');
        return {
            success: false,
        };
    }

    public renderContent() {
        const { securityMessage } = this.context;
        if (!securityMessage) {
            return nothing;
        }

        const locked = securityMessage?.errorCode === ErrorType.Locked;
        const isVerify =
            !securityMessage?.errorCode || securityMessage?.errorCode === ErrorType.Verify;
        const { sendMessage } = securityMessage;

        return !locked
            ? html`<div class="caption">
                  <p><b>Please check your phone and reply to the prompt</b></p>
                  ${sendMessage ? html`<p>${sendMessage}</p>` : nothing}
                  <p>
                      We need to ensure your identity for the security of your account. Please check
                      your phone and reply to the prompt.
                  </p>
                  ${isVerify
                      ? html`<tm-circle-progress class="large-loader"></tm-circle-progress>`
                      : nothing}
              </div>`
            : nothing;
    }

    public renderActions() {
        const { securityMessage, verifying, verify, cancel } = this.context;
        const errorCode = securityMessage?.errorCode;

        if (!errorCode || errorCode === ErrorType.Verify) {
            return nothing;
        }

        const boundVerify = verify.bind(this.context);
        const canRetry = securityMessage?.errorCode !== ErrorType.Locked;
        const securityPrompt =
            !securityMessage.methodUsed || securityMessage.methodUsed === 'Text'
                ? 'Call me instead'
                : 'Text me instead';

        return html`<div name="actions">
            ${canRetry
                ? html`
                      <tm-button
                          importance="primary"
                          .type="${TmButtonType.Submit}"
                          .disabled=${verifying}
                          @click=${verify}
                      >
                          ${!securityMessage.methodUsed || securityMessage.methodUsed === 'Text'
                              ? 'Resend text message'
                              : 'Call again'}
                      </tm-button>
                      ${securityMessage.hasAlternate
                          ? html` <tm-button
                                importance="secondary"
                                .disabled=${verifying}
                                @click=${boundVerify}
                            >
                                ${securityPrompt}
                            </tm-button>`
                          : nothing}
                  `
                : nothing}
            ${!this.context.disableClose
                ? html`<tm-button .type="${TmButtonType.Clear}" @click=${cancel}>
                      ${canRetry ? 'Cancel' : 'Close'}
                  </tm-button>`
                : nothing}
        </div>`;
    }
}
